import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "universal-cookie";
import apiError from "@/errors/api.error";
import {
  addErrorNotification,
  addInfoNotification,
} from "@/components/framework/notify";

export default () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["uploadPersonalDocuments"],
    mutationFn: async ({ prefix, documents, onUploadProgress }) => {
      const fd = new FormData();

      fd.set("prefix", prefix);

      for (const document of documents) {
        fd.append("files", document);
      }

      try {
        const res = await axios.post(
          "/api/gateway/personal-documents/documents",
          fd,
          {
            headers: {
              authorization: `Bearer ${new Cookies().get("accessToken")}`,
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              if (onUploadProgress && progressEvent.total) {
                const percentCompleted = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total,
                );
                onUploadProgress(percentCompleted);
              }
            },
          },
        );

        return res.data;
      } catch (e) {
        throw apiError.create(e.response.data.message);
      }
    },
    onSuccess: () => {
      // Invalidate and refetch personal documents
      queryClient.invalidateQueries(["personalDocuments"]);

      addInfoNotification({
        tid: "success",
      });
    },
    onError: (error) => {
      addErrorNotification({
        tid: "generic.unknown_error",
        message: error.message,
      });
    },
  });
};
